import ChannelEditDescPage from '../ChannelEdit/ChannelEditDescPage'

export default ChannelEditDescPage


// WEBPACK FOOTER //
// ./src/pages/LectureEdit/LectureEditDescPage.js